// @flow

import { FetchApi } from "../model/fetch";

const ERROR_MSG_GENERIC =
    "An unexpected error has occurred. Please try again later. If problem persists, please contact your <a href='/storefinder'>local branch.</a>";

export class BaseService {
    _basepath: string;
    _fetch: FetchApi;
    constructor(
        fetchApi: FetchApi,
        option: { basepath: string }
    ) {
        this._basepath = option.basepath;
        this._fetch = fetchApi;
    }
    apipath(path: string) {
        if (path.indexOf("/") !== 0) {
            path = "/" + path;
        }
        return `${this._basepath}${path}`;
    }
    apipathWithParam(path: string, param?: ?Object) {
        path = this.apipath(path);
        if (param) {
            const pathContainsQuestionMark = path.indexOf("?") !== -1;
            if (!pathContainsQuestionMark) {
                path += "?";
            }
            path += this.toQueryString(param);
        }
        return path;
    }
    constructRequest(method: "GET" | "POST", data?: ?Object) {
        let ret = {
            method: method,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Cache: "no-cache",
                "cache-control": "no-store"
            },
            credentials: "include",
            body: data === undefined ? "" : JSON.stringify(data),
            cache: "no-store"
        };
        if (method === "GET") {
            delete ret.body;
        }
        return ret;
    }
    async exchange(
        method: "GET" | "POST",
        path: string,
        param?: ?Object,
        data?: ?Object
    ) {
        const url = this.apipathWithParam(path, param);
        const requestOption = this.constructRequest(method, data);
        const resp = await this._fetch(url, requestOption);
        let resultData: string = "";
        try {
            const text = await resp.text();
            resultData = text ? JSON.parse(text) : "";
        } catch (e) {
            throw this.error(resp.status);
        }
        if (resp.ok) {
            return resultData;
        } else {
            throw this.error(resp.status, (resultData: any).errorMessage);
        }
    }
    fetch(path: string, param?: ?Object): any {
        return this.exchange("GET", path, param);
    }
    post(path: string, param?: ?Object, data?: ?Object): any {
        return this.exchange("POST", path, param, data);
    }
    error(status: number, errorMessage?: string) {
        //^^^ above to ensure errorMessage always make sense
        //even if it is not provided

        const isNot4XXX = Math.floor(status / 100) !== 4;

        //following ensure the non-4XX errorMessage is always overridden by genric error message
        errorMessage =
            isNot4XXX || !errorMessage ? ERROR_MSG_GENERIC : errorMessage;

        return {
            status,
            errorMessage: errorMessage
        };
    }
    isError_RecordNotFound(error: { status: number }) {
        return error.status === 404;
    }
    isError_ServerError(error: { status: number }) {
        return error.status >= 500 && error.status < 600;
    }
    toQueryString(param: Object) {
        if (!param) {
            return "";
        }
        return Object.keys(param).reduce((acc, curr) => {
            return (
                acc +
                (acc ? "&" : "") +
                curr +
                "=" +
                encodeURIComponent(param[curr])
            );
        }, "");
    }
}
